import {IArenaGameFilter} from "./arena-game-filter.interface";
import {IGameFilterDefinition} from "../interfaces/game-filter-definition.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {GameInfo} from "../../games/game-info";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

export class DynamicArenaGameFilter implements IArenaGameFilter {
    constructor(private readonly filterDefinition: IGameFilterDefinition,
                private readonly services: IServiceFactoryExtended) {
    }

    readonly isDynamicFilter = true;

    get id(): string {
        return this.filterDefinition.id;
    }

    get isApplied(): boolean {
        return this.services.gamesFilter.isFilterApplied(this.id);
    }
    readonly text: string;

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
        return this.filterDefinition.applyFilter(gameInfo);
    }

}